import { Component, inject, input, viewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { type ChildClient } from '@models';
import { Store } from '@ngrx/store';
import { ClientManagementActions } from '@ngrx-store';
import { ConfirmationDialogComponent } from '@ui';

@Component({
  imports: [MatSlideToggle, MatTooltip],
  selector: 'avs-require-totp',
  templateUrl: './require-totp.component.html',
})
export class RequireTotpComponent {
  client = input.required<ChildClient | undefined>();
  private dialog = inject(MatDialog);
  private store = inject(Store);
  private toggle = viewChild(MatSlideToggle);

  protected onChange(checked: boolean) {
    if (checked) {
      this.updateRequireTotp(true);

      return;
    }

    ConfirmationDialogComponent.open(this.dialog, {
      confirmBtnText: 'TURN OFF',
      description: 'If you will turn off 2FA mechanics, all users’ 2FA data will be deleted. Are you sure?',
      title: 'Turn off 2FA?',
    }).subscribe((confirmed: boolean | undefined) => {
      if (confirmed) {
        this.updateRequireTotp(false);
      } else {
        this.toggle()?.writeValue(true);
      }
    });
  }

  protected updateRequireTotp(requireTotp: boolean) {
    this.store.dispatch(ClientManagementActions.updateClientRequireTotp({ clientClientId: this.client()!.id, requireTotp }));
  }
}
